import buildQuery from 'odata-query';
import moment from 'moment';
import { CSVModalController } from 'modules/shared/CSVModal/CSVModalController';
import CSVModalView from 'modules/shared/CSVModal/CSVModalView.html';
import { AttendanceConstants } from '../AttendanceConstants';
import { sortByStringValue, sortByStringLabel } from 'data/function';
import { DeskControllerBase } from '../DeskControllerBase';
import { FilterTypes } from '../FilterTypes';
import { AttendanceFeatures } from 'modules/application/detail/attendance/AttendanceFeatures';
import { getDatetimeFromBrFormat, getDatetimeByOffsetFromBrFormat, getDateFromBrFormat, getDaysToToday, getDateTime, DATA_RETENTION_DAYS_LIMIT, getDateTimeFromISOFormat, formatSecondsToDHMSMS, formatTimeString, } from 'modules/application/detail/attendance/AttendanceUtils';
import { DATA_RETENTION_ERROR_DISPLAY, TICKET_HISTORY_EXPORTED, TICKET_HISTORY_FILTERED, TICKET_HISTORY_SELECTED, TIMEZONE_CHANGED, } from 'modules/application/detail/attendance/AttendanceSegmentEvents';
import { UserFeatures } from '../../users/UserFeatures';
import './History.scss';
import { ExportTicketModalController } from './exportTicketsModal/ExportTicketModalController';
import ExportTicketModalView from './exportTicketsModal/ExportTicketModalView.html';
import { ConfirmExportTicketModalController } from './confirmTicketsExportModal/ConfirmExportTicketModalController';
import ConfirmExportTicketModalView from './confirmTicketsExportModal/ConfirmExportTicketModalView.html';
import { BehaviorSubject, Subject } from 'rxjs';
import { characterLeftSquareBracketTreatment } from 'modules/application/detail/attendance/AttendanceUtils';
var TimeZoneFilterType;
(function (TimeZoneFilterType) {
    TimeZoneFilterType["LOCALUSER"] = "BYLOCALUSER";
    TimeZoneFilterType["CONFIGBOT"] = "BYCONFIGBOT";
})(TimeZoneFilterType || (TimeZoneFilterType = {}));
export class HistoryController extends DeskControllerBase {
    static $inject = ['application', 'DeskConfigurationService', 'LoadingService', 'TagsQueueService', '$scope', 'TeamService', 'HistoryService', 'SegmentService', 'UsersService', '$rootScope', '$stateParams', '$location', 'ModalService', 'ngToast', '$translate', 'BlipToastService', 'AccountService2', 'ApplicationService2', 'ConfigurationsService'];
    constructor(application, DeskConfigurationService, LoadingService, TagsQueueService, $scope, TeamService, HistoryService, SegmentService, UsersService, $rootScope, $stateParams, $location, ModalService, ngToast, $translate, BlipToastService, AccountService2, ApplicationService2, ConfigurationsService) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.TagsQueueService = TagsQueueService;
        this.$scope = $scope;
        this.TeamService = TeamService;
        this.HistoryService = HistoryService;
        this.SegmentService = SegmentService;
        this.UsersService = UsersService;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.ModalService = ModalService;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
        this.AccountService2 = AccountService2;
        this.ApplicationService2 = ApplicationService2;
        this.ConfigurationsService = ConfigurationsService;
        this.tickets = [];
        this.teams = [];
        this.tags = [];
        this.customers = [];
        this.showTimeZone = false;
        this.timeZoneOptions = [];
        this.customer = [];
        this.initialized = async () => {
            this.tickets = [];
            this.operator = '';
            this.team = '';
            this.tag = '';
            this.LoadingService.startLoading();
            try {
                await Promise.all([
                    this.bindTimeZoneOptions(),
                    this.getTeams(),
                    this.getOperators(),
                    this.getTags(),
                    !this.isSearchCustomerOnDemandTyping ? this.getCustomers() : undefined,
                ]).then(() => {
                    this.initializeAndBindAutocompleteList();
                    return this.setQueryStringsToTicketsQuery();
                }).then(() => {
                    if (this.$stateParams.offset) {
                        this.timeZoneSelectedOption = TimeZoneFilterType.CONFIGBOT;
                    }
                    else {
                        this.timeZoneSelectedOption = TimeZoneFilterType.LOCALUSER;
                    }
                    this.query();
                });
            }
            catch (error) {
                console.error('Failed loading page', error);
                const errorMsg = await this.$translate('utils.errorMsg.155');
                this.ngToast.danger(errorMsg);
            }
            finally {
                this.LoadingService.stopLoading();
            }
            this.SegmentService.createBotTrack('helpdesk-ticket-history-opened', this.application);
        };
        this.onChangeTicketIdTextFilter = (event) => {
            const { detail: { value } } = event;
            this.id = value === '' ? undefined : value;
        };
        this.selectTimeZone = async (event) => {
            if (this.timeZoneSelectedOption !== event.detail?.value) {
                this.SegmentService.createBotTrack(TIMEZONE_CHANGED, this.application);
                this.timeZoneSelectedOption = event.detail?.value;
                await this.query();
            }
        };
        this.selectCustomer = (event) => {
            const selectedValue = event.detail?.value;
            this.customer = undefined;
            if (selectedValue) {
                let customerFiltered = this.customers.find((customer) => customer.identity === selectedValue);
                if (!customerFiltered) {
                    customerFiltered = this.filteredCustomersSearch.find((customer) => customer.identity === selectedValue);
                }
                this.customer = customerFiltered;
                this.lastSearch.get(event.currentTarget.id).isSelected = true;
            }
        };
        this.changeCustomer = async (event) => {
            const observable = this.searchOnDemand(event, this.filteredCustomers, this.customCustomersSearch.bind(this));
            if (!observable) {
                return;
            }
            observable.subscribe(resultSearch => {
                this.filteredCustomersSearch = resultSearch;
                this.bindAutocomplete('#bdsAutocomplete_customers', JSON.stringify(resultSearch));
            });
        };
        this.searchOnDemand = (event, filtered, serviceSearch) => {
            let subject = new Subject();
            const input = event.target;
            const searchValue = input.value;
            const id = event.currentTarget.id;
            if (this.lastSearch.get(id)?.isSelected) {
                this.lastSearch.get(id).isSelected = false;
                return;
            }
            if (searchValue && searchValue.length >= 3) {
                this.lastSearch.get(id).typedIn = Date.now();
                setTimeout(async () => {
                    const startSameString = searchValue?.toLowerCase()?.startsWith(this.lastSearch.get(id).text?.toLowerCase());
                    const newSearch = !startSameString || this.lastSearch.get(id).count === 100;
                    if ((this.lastSearch.get(id).typedIn + 1000) <= Date.now() && newSearch) {
                        let resultSearch = await serviceSearch({
                            query: searchValue,
                        });
                        resultSearch = resultSearch.filter((customer) => {
                            return !filtered.some((filteredCustomer) => filteredCustomer.item.identity === customer.identity);
                        });
                        this.lastSearch.get(id).text = searchValue;
                        this.lastSearch.get(id).count = resultSearch.length;
                        subject.next(resultSearch);
                    }
                }, 1000);
            }
            else {
                this.lastSearch.get(id).text = undefined;
                this.lastSearch.get(id).count = 0;
                subject = new BehaviorSubject([]);
                subject.next([]);
            }
            return subject.asObservable();
        };
        this.selectOperator = (event) => {
            const selectedValue = event.detail?.value;
            this.operator = selectedValue || '';
        };
        this.selectTeam = (event) => {
            const selectedValue = event.detail?.value;
            this.team = selectedValue || '';
        };
        this.selectTag = (event) => {
            const selectedValue = event.detail?.value;
            this.tag = selectedValue || '';
        };
    }
    async redirectToNewScreenAndSetStorage() {
        this.SegmentService.createApplicationTrack({
            trackEvent: 'helpdesk-ticket-history-old-version-banner-new-version-clicked',
            application: this.application,
        });
        await new Promise(resolve => setTimeout(resolve, 800)); // Wait for the segment to be sent
        localStorage.setItem(AttendanceConstants.HISTORY_SCREEN, AttendanceConstants.MFE_SCREEN);
        this.redirectToNewScreen();
    }
    redirectToNewScreen() {
        window.open('/application/detail/' + this.application.shortName + '/attendance/desk/history', '_self');
    }
    async $onInit() {
        const phasedHistoryMfeFT = await AttendanceFeatures.phasedHistoryMfeFT();
        if (phasedHistoryMfeFT === AttendanceConstants.PORTAL_ONLY || phasedHistoryMfeFT === AttendanceConstants.MFE_ONLY) {
            localStorage.removeItem(AttendanceConstants.HISTORY_SCREEN);
        }
        if (phasedHistoryMfeFT === AttendanceConstants.MFE_ONLY) {
            this.redirectToNewScreen();
            return;
        }
        this.isNewScreenAvailable = phasedHistoryMfeFT !== AttendanceConstants.PORTAL_ONLY;
        this.searchText = '';
        this.isLoading = true;
        this.filteredTeams = this.filteredTeams ?? [];
        this.filteredOperators = this.filteredOperators ?? [];
        this.filteredTags = this.filteredTags ?? [];
        this.filteredIds = this.filteredIds ?? [];
        this.filteredCustomers = this.filteredCustomers ?? [];
        this.customer = undefined;
        this.noResultsFound = true;
        this.skip = 0;
        this.take = 20;
        this._canLoadMore = true;
        this.displayCustomer = '';
        this.showDataRetentionAlert = false;
        this.autoCompleteElementList = [];
        this.lastSearch = new Map();
        const text = await this.$translate('modules.application.detail.attendance.history.helperLink.title');
        const link = await this.$translate('modules.application.detail.attendance.history.helperLink.link');
        this.helperLink = { text, link };
        if (this.period === undefined) {
            const today = new Date();
            const momentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            this.period = {
                start: moment(momentDate)
                    .subtract(30, 'days')
                    .format('DD/MM/YYYY'),
                startTime: getDateTime(0, 0),
                end: moment(momentDate)
                    .add(1, 'days')
                    .format('DD/MM/YYYY'),
                endTime: getDateTime(23, 59),
            };
        }
    }
    async checkFeatures() {
        await super.checkFeatures();
        await this.verifyToggleFeatures();
        await this.initialized();
    }
    initializeAndBindAutocompleteList() {
        this.autoCompleteElementList = [
            {
                id: '#bdsAutocomplete_customers',
                options: this.customers,
            },
            {
                id: '#bdsAutocomplete_operators',
                options: this.operators,
            },
            {
                id: '#bdsAutocomplete_teams',
                options: this.teams,
            },
            {
                id: '#bdsAutocomplete_tags',
                options: this.tags,
            },
        ];
        this.autoCompleteElementList.forEach((autoComplete) => {
            this.bindAutocomplete(autoComplete.id);
            this.lastSearch.set(autoComplete.id.replace('#', ''), {});
        });
    }
    async bindTimeZoneOptions() {
        const account = await this.ApplicationService2.getAccount();
        const configTimezone = this.ConfigurationsService.loadTimezones(account);
        let defaultTimeZoneStr = configTimezone.name.split(/[()]/)[1].replace('UTC', '');
        defaultTimeZoneStr = configTimezone.key + ' (' + (defaultTimeZoneStr ? defaultTimeZoneStr : 'UTC') + ')';
        const localTimeZone = new Date().getTimezoneOffset() / 60 * (-1);
        let localTimeZoneStr = localTimeZone < 0 ? '-' : '+';
        localTimeZoneStr += ('0' + Math.abs(localTimeZone)).slice(-2) + ':00';
        const localTimeZoneLabel = await this.$translate('modules.application.detail.attendance.history.optionTimeZoneLocal', { offset: localTimeZoneStr });
        this.timeZoneOptions = [
            {
                value: TimeZoneFilterType.LOCALUSER,
                label: localTimeZoneLabel,
                offset: localTimeZone,
            },
            {
                value: TimeZoneFilterType.CONFIGBOT,
                label: defaultTimeZoneStr,
                offset: configTimezone.offset,
            },
        ];
        this.showTimeZone = (configTimezone.offset !== localTimeZone) && this.isAllowSelectTimeZone;
    }
    bindAutocomplete(id, options) {
        const autoComplete = this.autoCompleteElementList.find((element) => element.id === id);
        const element = autoComplete.element || document.querySelector(autoComplete.id);
        if (!element) {
            return;
        }
        element.options = options || JSON.stringify(autoComplete?.options);
        autoComplete.element = element;
    }
    async verifyToggleFeatures() {
        this.isUsingStartsWithOnContactsSearch = await UserFeatures.isUsingStartsWithOnContactsSearch();
        this.isSearchCustomerOnDemandTyping = await UserFeatures.isSearchCustomerOnDemandTyping();
        this.isAllowSelectTimeZone = await AttendanceFeatures.isAllowSelectTimeZone();
        this.isTicketExportDownloadEnabled = await AttendanceFeatures.isTicketExportDownloadEnabled();
        this.isTagsQueueFeaturetoggleEnabled = await AttendanceFeatures.isTagsQueueEnabled();
        this.isWidgetBlipChatHelpCenterEnabled = await AttendanceFeatures.isWidgetBlipChatHelpCenterEnabled();
        this.calculateSLAPolicy = await AttendanceFeatures.isSLAPolicyMfeEnabled();
    }
    async setQueryStringsToTicketsQuery() {
        if (this.$stateParams.tag) {
            this.setQueryStringToFilter(this.$stateParams.tag, this.addTagFilter.bind(this));
        }
        if (this.$stateParams.team) {
            this.setQueryStringToFilter(this.$stateParams.team, this.addTeamFilter.bind(this));
        }
        if (this.$stateParams.sequentialId) {
            this.setQueryStringToFilter(this.$stateParams.sequentialId, this.addIdFilter.bind(this));
        }
        if (this.$stateParams.operator) {
            this.setQueryStringToFilter(this.$stateParams.operator, this.addOperatorFilter.bind(this));
        }
        if (this.$stateParams.customer) {
            await this.setCustomerQueryStringToFilter();
        }
        if (this.$stateParams.start) {
            const startDate = getDateTimeFromISOFormat(this.$stateParams.start);
            this.period.start = moment(startDate.toISOString()).format('DD/MM/YYYY');
            this.period.startTime = startDate;
        }
        if (this.$stateParams.end) {
            const endDate = getDateTimeFromISOFormat(this.$stateParams.end);
            this.period.end = moment(endDate.toISOString()).format('DD/MM/YYYY');
            this.period.endTime = endDate;
        }
    }
    async setCustomerQueryStringToFilter() {
        const customerStateParam = this.$stateParams.customer;
        if (typeof customerStateParam === 'string') {
            const customerSearched = await this.customCustomersSearch({
                query: customerStateParam,
            });
            if (customerSearched.length > 0) {
                this.customer = customerSearched[0];
                this.addCustomerFilter(this.customer);
            }
        }
        if (typeof customerStateParam === 'object') {
            const promisesCustomerSearch = [];
            customerStateParam.forEach((element) => {
                const promise = this.customCustomersSearch({
                    query: element,
                }).then((customerSearched) => {
                    if (customerSearched.length > 0) {
                        this.customer = customerSearched[0];
                        this.addCustomerFilter(this.customer);
                    }
                });
                promisesCustomerSearch.push(promise);
            });
            await Promise.all(promisesCustomerSearch);
        }
    }
    setQueryStringToFilter(queryStringValues, addFilter) {
        if (typeof queryStringValues === 'string') {
            addFilter(queryStringValues);
        }
        if (typeof queryStringValues === 'object') {
            queryStringValues.forEach((element) => {
                addFilter(element);
            });
        }
    }
    setValuesToQueryString() {
        this.$location.search('operator', this.filteredOperators.map((operator) => operator.item.value));
        this.$location.search('customer', this.filteredCustomers.map((customer) => customer.item.identity));
        this.$location.search('team', this.filteredTeams.map((team) => team.item.value));
        this.$location.search('tag', this.filteredTags.map((tag) => tag.item.value));
        this.$location.search('sequentialId', this.filteredIds.map((id) => id.item));
        this.$location.search('start', getDatetimeFromBrFormat(this.period.start, this.period.startTime).toISOString());
        this.$location.search('end', getDatetimeFromBrFormat(this.period.end, this.period.endTime).toISOString());
    }
    async queryByDateChange() {
        this.createFilterTrack(FilterTypes.Date);
        this.query();
    }
    async queryByTimeChange() {
        this.createFilterTrack(FilterTypes.Time);
        this.query();
    }
    /**
     * Query for tickets using all the selected filters
     * @param reset
     */
    async query(reset = true) {
        this.isLoading = true; // loading icon
        this.setValuesToQueryString();
        if (reset) {
            this.tickets = [];
            this.skip = 0;
            this._canLoadMore = true;
        }
        const datesDiffByDays = getDaysToToday(getDateFromBrFormat(this.period.start));
        if (datesDiffByDays > DATA_RETENTION_DAYS_LIMIT) {
            this.showDataRetentionAlert = true;
            await this.createRetentionDataTrack();
            this.assertIfChatTranscriptionExportingIsEnabled();
            if (this.isChatTranscriptionExportingEnabled) {
                this.SegmentService.createBotTrack('helpdesk-ticket-history-filtered-3months', this.application);
            }
            this.isLoading = false;
            return;
        }
        try {
            this.showDataRetentionAlert = false;
            const filter = this.getFilters();
            const { items } = await this.HistoryService.get(filter, this.skip, this.take, this.calculateSLAPolicy);
            if (items.length === 0) {
                this._canLoadMore = false;
                return;
            }
            const promises = [];
            for (const item of items) {
                if (item.agentIdentity) {
                    const operator = this.operators.find((x) => x.identity === item.agentIdentity);
                    if (operator) {
                        item.fullName =
                            operator.fullName ||
                                decodeURIComponent(item.agentIdentity.split('@')[0]);
                    }
                    else {
                        promises.push(this.TeamService.getAccount(item.agentIdentity)
                            .then((resource) => {
                            item.fullName = resource.fullName;
                        })
                            .catch((e) => {
                            item.fullName =
                                item.fullName ||
                                    decodeURIComponent(item.agentIdentity.split('@')[0]);
                        }));
                    }
                }
                const promise = this.TeamService.getContact(item.customerIdentity)
                    .then((resource) => {
                    item.customerName = resource.name;
                    item.customerName =
                        item.customerName ||
                            decodeURIComponent(item.customerIdentity.split('@')[0]);
                })
                    .catch((e) => {
                    item.customerName =
                        item.customerName ||
                            decodeURIComponent(item.customerIdentity.split('@')[0]);
                });
                promises.push(promise);
            }
            await Promise.all(promises);
            this.tickets = this.tickets.concat(items);
        }
        catch (e) {
            console.error('Failed to get tickets data', e);
            this._canLoadMore = false;
        }
        finally {
            this.isLoading = false;
            this.LoadingService.stopLoading();
        }
    }
    async sendCSVByEmail() {
        const modal = await this.ModalService.showModal({
            template: CSVModalView,
            controller: CSVModalController,
            controllerAs: '$ctrl',
            inputs: {},
        });
        const email = await modal.close;
        if (email) {
            try {
                this.SegmentService.createBotTrack(TICKET_HISTORY_EXPORTED, this.application);
                const filter = this.getFiltersOData();
                await this.HistoryService.sendByEmail(email, filter);
                const successMsg = await this.$translate('modules.application.detail.attendance.history.sendCSVSendingMessage', { email: email });
                this.ngToast.success(successMsg);
            }
            catch (e) {
                console.error('Failed to send email', e);
                const errorMsg = await this.$translate('utils.errorMsg.155');
                this.ngToast.danger(errorMsg);
            }
        }
    }
    getAttendanceDetailsParams(item) {
        return ({
            id: this.UsersService.getDecodedUserIdentity(item.customerIdentity),
            ticketId: item.id,
            offset: this.timeZoneSelectedOption === TimeZoneFilterType.LOCALUSER
                ? undefined
                : this.getSelectedOffSet(true),
        });
    }
    async loadMore() {
        if (!this._canLoadMore || this.isLoading || this.showDataRetentionAlert) {
            return;
        }
        this.skip += this.take;
        await this.query(false);
    }
    disableLoader() {
        return this.isLoading || !this._canLoadMore;
    }
    getFiltersOData() {
        let filters = '';
        const offset = this.getSelectedOffSet();
        filters += `storageDate ge datetimeoffset'${getDatetimeByOffsetFromBrFormat(this.period.start, this.period.startTime, offset).toISOString()}'`;
        filters += ` and storageDate le datetimeoffset'${getDatetimeByOffsetFromBrFormat(this.period.end, this.period.endTime, offset).toISOString()}'`;
        filters += " and status ne 'Open' and status ne 'Waiting'";
        if (this.filteredTeams && this.filteredTeams.length > 0) {
            filters += ' and ';
            filters += '(';
            this.filteredTeams.forEach((item, index) => {
                if (index > 0) {
                    filters += ' or ';
                }
                filters += `Team eq '${this.characterTreatment(item.item.value)}'`;
            });
            filters += ')';
        }
        if (this.filteredOperators && this.filteredOperators.length > 0) {
            filters += ' and ';
            filters += '(';
            this.filteredOperators.forEach((item, index) => {
                if (index > 0) {
                    filters += ' or ';
                }
                filters += `AgentIdentity eq '${this.characterTreatment(item.item.identity)}'`;
            });
            filters += ')';
        }
        if (this.filteredTags && this.filteredTags.length > 0) {
            filters += ' and ';
            filters += '(';
            this.filteredTags.forEach((item, index) => {
                if (index > 0) {
                    filters += ' or ';
                }
                filters += `substringof('"${characterLeftSquareBracketTreatment(item.text)}"',TagsJson)`;
            });
            filters += ')';
        }
        if (this.filteredCustomers && this.filteredCustomers.length > 0) {
            filters += ' and ';
            filters += '(';
            this.filteredCustomers.forEach((item, index) => {
                if (index > 0) {
                    filters += ' or ';
                }
                filters += `substringof('${this.characterTreatment(item.item.identity)}',CustomerIdentity)`;
            });
            filters += ')';
        }
        if (this.filteredIds && this.filteredIds.length > 0) {
            filters += ' and ';
            filters += '(';
            this.filteredIds.forEach((item, index) => {
                if (index > 0) {
                    filters += ' or ';
                }
                filters += `SequentialId eq ${item.item}`;
            });
            filters += ')';
        }
        return filters;
    }
    getFilters() {
        const { calculateSLAPolicy } = this;
        return calculateSLAPolicy ? this.getFiltersAsUrlParams() : this.getFiltersOData();
    }
    getFiltersAsUrlParams() {
        const params = new URLSearchParams();
        const offset = this.getSelectedOffSet();
        const startDate = getDatetimeByOffsetFromBrFormat(this.period.start, this.period.startTime, offset).toISOString();
        const endDate = getDatetimeByOffsetFromBrFormat(this.period.end, this.period.endTime, offset).toISOString();
        params.append('beginDate', startDate);
        params.append('endDate', endDate);
        const addArrayParams = (array, paramName, transformFn = (val) => val) => {
            if (array && array.length > 0) {
                const values = array.map(item => encodeURIComponent(transformFn(item.item.identity || item.item.value || item.item))).join(',');
                params.set(paramName, values);
            }
        };
        addArrayParams(this.filteredTeams, 'teams');
        addArrayParams(this.filteredOperators, 'agentIdentities');
        addArrayParams(this.filteredCustomers, 'customerIdentities');
        addArrayParams(this.filteredIds, 'ticketIds');
        if (this.filteredTags && this.filteredTags.length > 0) {
            const tagValues = this.filteredTags
                .map(item => encodeURIComponent(characterLeftSquareBracketTreatment(item.text)))
                .join(',');
            params.set('tags', tagValues);
        }
        return decodeURIComponent(params.toString());
    }
    characterTreatment(tag) {
        return tag.split('\'').join('[\\\']');
    }
    getSelectedOffSet(invertSignal = false) {
        return this.timeZoneOptions.filter((timezone) => timezone.value === this.timeZoneSelectedOption)[0]?.offset * (invertSignal ? -1 : 1);
    }
    createTicketSelectedTrack() {
        this.SegmentService.createBotTrack(TICKET_HISTORY_SELECTED, this.application);
    }
    createFilterTrack(filteredBy) {
        this.SegmentService.createBotTrack(TICKET_HISTORY_FILTERED, this.application, { filteredBy });
    }
    async createRetentionDataTrack() {
        await this.SegmentService.createBotTrack(DATA_RETENTION_ERROR_DISPLAY, this.application);
    }
    clearAutocompleteElements() {
        this.autoCompleteElementList.forEach((autoComplete) => {
            if (autoComplete.element) {
                autoComplete.element.value = undefined;
            }
        });
    }
    clearFilterInput() {
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.clearAutocompleteElements();
        document.querySelector('#ticket-id-filter-input').value = '';
        this.displayCustomer = '';
    }
    addTeamFilterClearInput() {
        this.createFilterTrack(FilterTypes.Team);
        this.addTeamFilter(this.team);
        this.clearFilterInput();
        this.query();
    }
    addTeamFilter(item) {
        if (!item) {
            return;
        }
        const removedItem = this.teams.find((team) => team.value == item);
        this.teams = this.teams.filter((team) => team.value != item);
        this.filteredTeams = this.filteredTeams.concat({
            text: removedItem.label,
            item: removedItem,
        });
        this.bindAutocomplete('#bdsAutocomplete_teams', JSON.stringify(this.teams));
    }
    addCustomerFilterClearInput() {
        this.createFilterTrack(FilterTypes.Customer);
        this.addCustomerFilter(this.customer);
        this.clearFilterInput();
        this.query();
    }
    addCustomerFilter(item) {
        if (!item) {
            return;
        }
        this.customers = this.customers.filter((customer) => customer.identity !== this.customer.identity);
        this.filteredCustomers = this.filteredCustomers.concat({
            text: item.fullName,
            item: item,
        });
        this.bindAutocomplete('#bdsAutocomplete_customers', JSON.stringify(this.customers));
    }
    addTagFilterClearInput() {
        this.createFilterTrack(FilterTypes.Tag);
        this.addTagFilter(this.tag);
        this.clearFilterInput();
        this.query();
    }
    addTagFilter(item) {
        if (!item) {
            return;
        }
        const removedItem = this.tags.find((tag) => tag.value == item);
        this.tags = this.tags.filter((tag) => tag.value != item);
        this.filteredTags = this.filteredTags.concat({
            text: removedItem.text,
            item: removedItem,
        });
        this.bindAutocomplete('#bdsAutocomplete_tags', JSON.stringify(this.tags));
    }
    /**
     * Add an Id to filter and clear the filter input
     * @param item Id to be used on filter
     */
    addIdFilterClearInput(item) {
        this.createFilterTrack(FilterTypes.TicketId);
        if (!item) {
            return;
        }
        this.id = undefined;
        this.addIdFilter(item);
        this.query();
        this.$rootScope.$broadcast('ToggleDropdownItem');
        const input = document.querySelector('#ticket-id-filter-input');
        input.value = '';
    }
    /**
     * Add an Id to filter
     * @param item Id to be used on filter
     */
    addIdFilter(item) {
        if (!item) {
            return;
        }
        this.filteredIds = this.filteredIds.concat({
            text: item,
            item: item,
        });
    }
    addOperatorFilterClearInput() {
        this.createFilterTrack(FilterTypes.Agent);
        this.addOperatorFilter(this.operator);
        this.clearFilterInput();
        this.query();
    }
    addOperatorFilter(item) {
        if (!item) {
            return;
        }
        const removedItem = this.operators.find((operator) => operator.value == item);
        this.operators = this.operators.filter((operator) => operator.value != item);
        this.filteredOperators = this.filteredOperators.concat({
            text: `${removedItem.fullName} (${removedItem.email})`,
            item: removedItem,
        });
        this.bindAutocomplete('#bdsAutocomplete_operators', JSON.stringify(this.operators));
    }
    resetTerms() {
        this.filteredTeams = this.filteredTeams = [];
        this.filteredOperators = this.filteredOperators = [];
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.$rootScope.$broadcast('blip-select:clearInput');
        this.query();
    }
    removeTeam(items, removedItem) {
        this.teams = this.teams.concat(removedItem.item);
        this.teams = this.teams.sort(sortByStringLabel);
        this.filteredTeams = items;
        this.query();
        this.bindAutocomplete('#bdsAutocomplete_teams', JSON.stringify(this.teams));
    }
    removeOperator(items, removedItem) {
        this.operators = this.operators.concat(removedItem.item);
        this.operators = this.operators.sort(sortByStringValue);
        this.filteredOperators = items;
        this.query();
        this.bindAutocomplete('#bdsAutocomplete_operators', JSON.stringify(this.operators));
    }
    removeTag(items, removedItem) {
        this.tags = this.tags.concat(removedItem.item);
        this.tags = this.tags.sort(sortByStringValue);
        this.filteredTags = items;
        this.query();
        this.bindAutocomplete('#bdsAutocomplete_tags', JSON.stringify(this.tags));
    }
    /**
     * Callback function for when an Id is removed from the filters
     * @param items Ids used on filter
     */
    removeId(items) {
        this.filteredIds = items;
        this.query();
    }
    removeCustomer(items, removedItem) {
        this.customers = this.customers.concat(removedItem.item);
        this.customers = this.customers.sort(sortByStringValue);
        this.filteredCustomers = items;
        this.query();
        if (!this.isSearchCustomerOnDemandTyping) {
            this.bindAutocomplete('#bdsAutocomplete_customers', JSON.stringify(this.customers));
        }
    }
    formatSecondsToTime(time) {
        return formatTimeString(formatSecondsToDHMSMS(time));
    }
    getFiltersOperators() {
        let filters = '';
        if (this.filteredOperators && this.filteredOperators.length > 0) {
            filters += ' and ';
            filters += '(';
            this.filteredOperators.forEach((item, index) => {
                if (index > 0) {
                    filters += ' and ';
                }
                filters += `AgentIdentity ne '${item.item.identity}'`;
            });
            filters += ')';
        }
        return filters;
    }
    async getOperators() {
        try {
            const filters = this.getFiltersOperators();
            const attendants = await this.TeamService.getAllAttendants(filters);
            const promises = [];
            for (const item of attendants) {
                const promise = this.TeamService.getAccount(item.identity)
                    .then((resource) => {
                    item.fullName = resource.fullName;
                    item.email = resource.email;
                    item.email =
                        item.email ||
                            decodeURIComponent(item.identity.split('@')[0]);
                    item.fullName =
                        item.fullName || item.email.split('@')[0];
                    item.value = item.fullName;
                    item.label = item.fullName;
                })
                    .catch((e) => {
                    item.email =
                        item.email ||
                            decodeURIComponent(item.identity.split('@')[0]);
                    item.fullName =
                        item.fullName || item.email.split('@')[0];
                    item.value = item.fullName;
                    item.label = item.fullName;
                });
                promises.push(promise);
            }
            await Promise.all(promises);
            this.operators = attendants.sort(sortByStringValue);
        }
        catch (e) { }
    }
    async getTeams() {
        try {
            const { items } = await this.TeamService.getTeams(this.application);
            items.push({
                name: AttendanceConstants.DIRECT_TRANSFER_TEAM,
                label: await this.$translate('directTransfer'),
            });
            this.teams = items
                .map((item) => ({
                ...item,
                value: item.name,
                label: item.label ?? item.name,
            }))
                .sort(sortByStringLabel);
        }
        catch (e) {
            console.error('Failed to get teams data', e);
        }
    }
    setFilterLikeCustomer(value) {
        this.customer = {};
        this.customer.fullName = value;
        this.customer.identity = value;
    }
    async customCustomersSearch({ query }) {
        const filter = {
            or: this.isUsingStartsWithOnContactsSearch
                ? [
                    `startswith(name,'${query}')`,
                    `startswith(identity,'${query}')`,
                    `startswith(email,'${query}')`,
                    `startswith(phoneNumber,'${query}')`,
                ]
                : [
                    `substringof('${query}',name)`,
                    `substringof('${query}',identity)`,
                    `substringof('${query}',email)`,
                    `substringof('${query}',phoneNumber)`,
                ],
        };
        const filterQuery = buildQuery({ filter });
        let finalQuery = '&$filter=';
        if (filterQuery) {
            let filterQueryContent = filterQuery.split('?$filter=')[1];
            filterQueryContent += ' and ';
            const encodedQueryContent = encodeURIComponent(filterQueryContent);
            finalQuery += `${encodedQueryContent}`;
        }
        const excludeAttendantsQuery = encodeURIComponent("(source ne 'blip.ai' or source eq null)");
        finalQuery += excludeAttendantsQuery;
        try {
            const { items } = await this.UsersService.getUsers(finalQuery, 0, 100);
            const filteredItems = items.map((item) => ({
                ...item,
                fullName: this.buildCustomerInfo(item),
                value: item.identity,
                label: this.buildCustomerInfo(item),
            }));
            this.searchedCustomers = filteredItems;
            return filteredItems;
        }
        catch (e) {
            console.error('Failed to get customers data', e);
            return [];
        }
    }
    async getCustomers() {
        try {
            const filterExcludeAttendance = encodeURIComponent("(source ne 'blip.ai' or source eq null)");
            const { items } = await this.UsersService.getUsers(`&$filter=${filterExcludeAttendance}`, 0, 100);
            this.customers = items
                .map((item) => ({
                ...item,
                fullName: this.buildCustomerInfo(item),
                value: item.identity,
                label: this.buildCustomerInfo(item),
            }))
                .sort(sortByStringValue);
        }
        catch (e) { }
    }
    buildCustomerInfo(item) {
        const phoneNumber = item.phoneNumber ? ` - ${item.phoneNumber}` : '';
        const fullName = this.createCustomerFullName(item);
        return fullName + phoneNumber;
    }
    createCustomerFullName(item) {
        if (item.name && item.email) {
            return `${item.name} - ${item.email}`;
        }
        else if (item.name) {
            return `${item.name} - ${item.identity}`;
        }
        else if (item.email) {
            return `${item.email} - ${item.identity}`;
        }
        else {
            return `${item.identity}`;
        }
    }
    async getTags() {
        try {
            const { items: tagsClosedTicket, } = await this.HistoryService.getTags(this.isTagsQueueFeaturetoggleEnabled);
            this.tags = tagsClosedTicket
                .map(tag => ({
                text: tag,
                value: tag,
                label: tag,
            }))
                .sort(sortByStringValue);
        }
        catch (e) {
            console.error('Failed to get tags data', e);
        }
    }
    assertIfChatTranscriptionExportingIsEnabled() {
        this.isChatTranscriptionExportingEnabled = (this.filteredCustomers.length <= 1 && this.filteredIds.length <= 10) && !(this.filteredCustomers.length === 0 && this.filteredIds.length === 0);
    }
    async exportToEmail(isTranscriptionExporting) {
        if (!this.isChatTranscriptionExportingEnabled && isTranscriptionExporting) {
            return;
        }
        if (!isTranscriptionExporting) {
            this.SegmentService.createBotTrack('helpdesk-ticket-history-exported-ticket-list', this.application);
        }
        else {
            this.SegmentService.createApplicationTrack({ trackEvent: 'helpdesk-ticket-history-exported-transcription', application: this.application, payload: {} });
        }
        const modal = await this.ModalService.showModal({
            template: ExportTicketModalView,
            controller: ExportTicketModalController,
            controllerAs: '$ctrl',
            inputs: {
                period: this.period,
                isTranscriptionExporting: isTranscriptionExporting,
                teams: this.filteredTeams,
                operators: this.filteredOperators,
                tags: this.filteredTags,
                customers: this.filteredCustomers,
                ids: this.filteredIds,
            },
        });
        const isFiltersConfirmmed = await modal.close;
        if (typeof isFiltersConfirmmed === 'boolean' && isFiltersConfirmmed === true) {
            try {
                const filters = await this.createExportToEmailFilters();
                if (isTranscriptionExporting) {
                    await this.HistoryService.sendArchivedByEmail(filters);
                    this.SegmentService.createBotTrack('helpdesk-ticket-history-confirmed-transcription', this.application, { ExportSuccessful: true });
                }
                else {
                    await this.HistoryService.sendTicketListArchivedByEmail(filters);
                    this.SegmentService.createBotTrack('helpdesk-ticket-history-confirmed-ticket-list', this.application, { ExportSuccessful: true });
                }
                await this.ModalService.showModal({
                    template: ConfirmExportTicketModalView,
                    controller: ConfirmExportTicketModalController,
                    controllerAs: '$ctrl',
                    inputs: {
                        isTranscriptionExporting,
                    },
                });
            }
            catch (e) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('modules.application.detail.attendance.history.exportTickets.error.msg'),
                    title: await this.$translate('modules.application.detail.attendance.history.exportTickets.error.title'),
                });
                this.SegmentService.createBotTrack(isTranscriptionExporting ? 'helpdesk-ticket-history-confirmed-transcription' : 'helpdesk-ticket-history-confirmed-ticket-list', this.application, { ExportFailed: true });
            }
        }
    }
    async createExportToEmailFilters() {
        const email = await this.AccountService2.me().then(item => String(item.email));
        const customers = this.filteredCustomers.map(customer => customer.item.identity);
        const ticketSeqId = this.filteredIds.map(ticket => ticket.item);
        const teams = this.filteredTeams.map(team => team.text);
        const attendants = this.filteredOperators.map(operator => operator.item.identity);
        const tags = this.filteredTags.map(tag => tag.text);
        const endTimeParts = this.period?.end.split('/');
        const endTime = new Date(+endTimeParts[2], endTimeParts[1] - 1, +endTimeParts[0], this.period?.endTime.getHours(), this.period?.endTime.getMinutes()).toISOString();
        const startTimeParts = this.period?.start.split('/');
        const startTime = new Date(+startTimeParts[2], startTimeParts[1] - 1, +startTimeParts[0], this.period?.startTime.getHours(), this.period?.startTime.getMinutes()).toISOString();
        return {
            email,
            customers,
            ticketSeqId,
            teams,
            attendants,
            tags,
            endTime,
            startTime,
        };
    }
}
HistoryController.$inject = ['application', 'DeskConfigurationService', 'LoadingService', 'TagsQueueService', '$scope', 'TeamService', 'HistoryService', 'SegmentService', 'UsersService', '$rootScope', '$stateParams', '$location', 'ModalService', 'ngToast', '$translate', 'BlipToastService', 'AccountService2', 'ApplicationService2', 'ConfigurationsService'];
